import { createSlice } from "@reduxjs/toolkit";

const compareSlice = createSlice({
    name: "compare",
    initialState: { cars: [] },
    reducers: {
        addToCompare: (state, action) => {
            if (state.cars.length < 3 && !state.cars.find(c => c.id === action.payload.id)) {
                state.cars.push(action.payload);
            }
        },
        removeFromCompare: (state, action) => {
            state.cars = state.cars.filter(c => c.id !== action.payload);
        },
        clearCompare: (state) => {
            state.cars = [];
        },
    },
});

export const { addToCompare, removeFromCompare, clearCompare } = compareSlice.actions;
export default compareSlice.reducer;
